/*
 * @Description: 账户详情相关
 * @Date: 2025-05-22 19:04:55
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { EntpActOpenParams, EntpActOpenDetailData } from '../data-source/types';
import { entpActOpenDetail, entpActOpen } from '../data-source/apis';
import { PayPassagewayCode } from '@/common/types/bank';
import { useBank } from '../hooks/index';
import { XrkMessage } from 'xrk-components';

const createDataTemp: () => EntpActOpenParams = function () {
  return {
    fyChannel: null,
    companyPhone: '',
    companyMainType: null,
    companyBusinessAddress: '',
    openAccountType: 1,
    openAccountCode: '',
    companyBusinessStartAt: '',
    companyBusinessEndAt: '',
    companyBusinessLicense: '',
    majorCategory: '',
    subCategory: '',
    businessDesc: '',
    mcc: '',
    provinceCode: null,
    cityCode: null,
    areaCode: null,
    provinceName: '',
    cityName: '',
    areaName: '',
    registeredCapital: null,
    businessScope: '',
    legalPersonName: '',
    legalPersonCardCode: '',
    legalPhone: '',
    legalPersonCardStartAt: '',
    legalPersonCardEndAt: '',
    legalPersonCardZheng: '',
    legalPersonCardFan: '',
    openBankName: '',
    openBankNode: '',
    openName: '',
    openBankNumber: '',
    transactorName: '',
    transactorCardCode: '',
    transactorPhone: '',
    transactorCardZheng: '',
    transactorCardFan: '',
    transactorCardStartAt: '',
    transactorCardEndAt: '',
    transactorEmail: '',
    fyBeneficiaryInfoList: [
      {
        name: '', // 收益人姓名
        certTp: null, // 证件类型 0身份证 1外国护照
        certNo: '', // 证件号 身份证号 统一社会信用代码
        validDateStart: '', // 证件有效期起
        validDateEnd: '', // 证件有效期止
        mobile: '', // 收益人手机号
        address: '', // 收益人地址
        portraitFilePath: '', // 正面
        badgeFilePath: '', // 背面
        beneficiaryType: null
      }
    ],
    fyShareholderInfoList: [
      {
        name: '', // 股东姓名
        certTp: null, // 0身份证 1营业执照
        certNo: '', // 证件号
        validDateStart: '', // 证件有效期起
        validDateEnd: '', // 证件有效期止
        mobile: '', // 收益人手机号
        portraitFilePath: '', // 身份证正，营业执照
        badgeFilePath: '' // 身份证反，无营业执照
      }
    ],
    companyName: '',
    companyCardNo: '',
    payPassagewayCode: null
  };
};

export default defineStore(
  'useAccountInfoStoreSetup',
  () => {
    const { banks, updateBanks } = useBank();
    const agree = ref(false);
    const formRef = ref(null);
    const payPassagewayCode = ref<PayPassagewayCode>();
    // 需要对数据初始设置去entpActOpenDetailTranslator中处理
    const formData = ref<EntpActOpenParams>(createDataTemp());
    const authLists = ref<
      Pick<EntpActOpenDetailData, 'platformAuthList' | 'bankAuthList'>
    >({
      platformAuthList: [],
      bankAuthList: []
    });

    const setPayPassagewayCode = code => {
      payPassagewayCode.value = code;
    };
    const bank = computed(() => {
      const v = banks.value.find(
        item => item.value === payPassagewayCode.value
      );
      return v || { platformAuthStatus: null };
    });
    const disabled = computed(() => {
      return [1, 3, 4, 6, 7].includes(bank.value?.platformAuthStatus);
    });
    const init = async () => {
      updateBanks();
      if (!payPassagewayCode.value) return;
      const {
        data: { platformAuthList, bankAuthList, ...openInfo }
      } = await entpActOpenDetail({
        payPassagewayCode: payPassagewayCode.value
      });
      authLists.value = {
        platformAuthList,
        bankAuthList
      };
      // 组件内自己初始对应数据
      formData.value = Object.assign(createDataTemp(), openInfo);
    };

    const onSubmit = async () => {
      if (!agree.value) return;
      await formRef.value.validate();
      await entpActOpen({
        ...formData.value,
        payPassagewayCode: payPassagewayCode.value
      });
      XrkMessage.success('提交成功');
      updateBanks();
      // TODO: 线下开通后，进入结算中心。线上与全都展示按线上流程处理
      // if (accountInfo.value.offlineProject === 2) {
      //   // to main
      // }
    };

    return {
      authLists,
      formData,
      formRef,
      onSubmit,
      init,
      payPassagewayCode,
      setPayPassagewayCode,
      agree,
      banks,
      bank,
      disabled
    };
  },
  {
    persist: false
  }
);
